import type { ReactNode } from 'react'

export function Icon({ children, size = 20 }: { children: ReactNode; size?: number }) {
  return <svg aria-hidden="true" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
}

export const icons = {
  home: <Icon><path d="m3 11 9-8 9 8"/><path d="M5 10v11h14V10M9 21v-7h6v7"/></Icon>,
  select: <Icon><path d="m5 3 13 9-6 1 3 6-3 2-3-6-4 4z"/></Icon>,
  animate: <Icon><path d="m9 5 11 7-11 7zM3 7h3M2 12h4M3 17h3"/></Icon>,
  marker: <Icon><path d="m14 4 6 6L10 20H4v-6zM13 5l6 6"/></Icon>,
  line: <Icon><path d="M4 19 19 4M12 4h7v7"/></Icon>,
  eraser: <Icon><path d="m7 20-4-4L15 4l6 6-10 10zM13 20H7"/></Icon>,
  undo: <Icon><path d="M9 7 4 12l5 5M5 12h8a6 6 0 0 1 6 6"/></Icon>,
  redo: <Icon><path d="m15 7 5 5-5 5M19 12h-8a6 6 0 0 0-6 6"/></Icon>,
  save: <Icon><path d="M5 3h12l3 3v15H4V3zM8 3v6h8V3M8 21v-7h8v7"/></Icon>,
  shield: <Icon><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11z"/></Icon>,
  flip: <Icon><path d="M3 7h15M15 4l3 3-3 3M21 17H6M9 14l-3 3 3 3"/></Icon>,
  expand: <Icon><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/></Icon>,
  plus: <Icon><path d="M12 5v14M5 12h14"/></Icon>,
  board: <Icon><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="12" r="3"/><path d="M3 12h6M15 12h6"/></Icon>,
  setup: <Icon><circle cx="7" cy="7" r="2.5"/><circle cx="17" cy="7" r="2.5"/><circle cx="7" cy="17" r="2.5"/><circle cx="17" cy="17" r="2.5"/><path d="M9.5 7h5M7 9.5v5M17 9.5v5M9.5 17h5"/></Icon>,
  players: <Icon><circle cx="9" cy="7" r="3"/><path d="M3 21v-3a6 6 0 0 1 12 0v3M16 4a3 3 0 0 1 0 6M21 21v-3a6 6 0 0 0-4-5.65"/></Icon>,
  controls: <Icon><path d="M4 6h16M4 12h16M4 18h16"/><circle cx="9" cy="6" r="2" fill="currentColor"/><circle cx="15" cy="12" r="2" fill="currentColor"/><circle cx="9" cy="18" r="2" fill="currentColor"/></Icon>,
}
